<template>
  <div class="w-full flex flex-col items-center justify-center">
    <div class="w-full h-12 hidden sm:flex"></div>
    <div class="card flex flex-col bg-white rounded max-w-sm w-full">
      <div class="flex flex-col w-full space-y-2">
        <button class="nxp-back-btn hidden sm:flex" @click="handleBackward">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <mask id="mask0_857_10485" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16"
              height="16">
              <rect width="16" height="16" fill="#696969" />
            </mask>
            <g mask="url(#mask0_857_10485)">
              <path
                d="M9.33362 11.7688L5.56445 7.99964L9.33362 4.23047L10.0361 4.93297L6.96945 7.99964L10.0361 11.0663L9.33362 11.7688Z"
                fill="#A9A9A9" />
            </g>
          </svg>
          Voltar
        </button>
        <span v-if="jobPositionReference" class="nxp-job-title">
          {{ jobPositionReference }}
        </span>
        <h1 class="nxp-title-form">
          Perguntas complementares
        </h1>
        
        <!-- Conteúdo quando há perguntas complementares -->
        <div v-if="(keywords && keywords.length > 0) || (roles && roles.length > 0)">
          <span class="nxp-subtitle-form">
            Confira as habilidades e cargos exigidos para esta vaga e marque os que você tem experiência para aumentar suas chances neste processo seletivo.
            <br><br>
            Para te ajudar, marcaremos as informações que já encontramos no seu currículo.
          </span>
        </div>
        
        <!-- Fallback quando não há perguntas complementares -->
        <div v-else class="flex flex-col items-center space-y-4">
          <div class="flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-4">
            <svg class="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
          </div>
          <h2 class="text-xl font-semibold text-gray-800 text-center">
            Nenhuma pergunta complementar
          </h2>
          <p class="text-gray-600 text-center leading-relaxed">
            Não há perguntas complementares específicas para esta vaga. 
            Você pode prosseguir diretamente para a próxima etapa do processo seletivo.
          </p>
        </div>
      </div>

      <!-- Conteúdo das perguntas complementares (só aparece quando há perguntas) -->
      <div v-if="(keywords && keywords.length > 0) || (roles && roles.length > 0)">
        <!-- Warning -->
        <div class="alert-warning">
          <div class="alert-icon">
            <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.99935 18.3334C14.6017 18.3334 18.3327 14.6024 18.3327 10C18.3327 5.39765 14.6017 1.66669 9.99935 1.66669C5.39698 1.66669 1.66602 5.39765 1.66602 10C1.66602 14.6024 5.39698 18.3334 9.99935 18.3334ZM9.99935 16.6667C6.31745 16.6667 3.33268 13.6819 3.33268 10C3.33268 6.31812 6.31745 3.33335 9.99935 3.33335C13.6812 3.33335 16.666 6.31812 16.666 10C16.666 13.6819 13.6812 16.6667 9.99935 16.6667ZM9.16602 12.5H10.8327V14.1667H9.16602V12.5ZM9.16602 5.83335H10.8327V10.8334H9.16602V5.83335Z" fill="#FF5900"/>
            </svg>
          </div>
          <div class="alert-content">
            <span class="font-bold" style="color: #FF5900;">Seja transparente com suas informações</span>
            Recrutadores irão conferir se você tem as habilidades e cargos que diz ter no seu perfil.
          </div>
        </div>

        <!-- Skills Section -->
        <div v-if="keywords && keywords.length > 0" class="flex w-full flex-col mt-8 mb-6 space-y-2">
          <h3 class="nxp-section-title">
            Marque apenas as habilidades, ferramentas e/ou atividades que você tem experiência
          </h3>
          <hr class="custom-hr">
        </div>

        <div v-if="keywords && keywords.length > 0" class="w-full flex flex-col space-y-3 mt-6">
          <div 
            v-for="(skill, index) in keywords" 
            :key="`skill-${index}`" 
            class="checkbox-container flex items-center space-x-3"
          >
            <input 
              type="checkbox" 
              :id="`skill-${index}`" 
              v-model="selectedKeywords"
              :value="skill"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
            >
            <label :for="`skill-${index}`" class="text-gray-900 cursor-pointer">
              {{ skill }}
            </label>
          </div>
        </div>

        <!-- Roles Section -->
        <div v-if="roles && roles.length > 0" class="flex w-full flex-col mt-10 mb-6 space-y-2">
          <h3 class="nxp-section-title">
            Marque apenas os cargos que você já trabalhou
          </h3>
          <hr class="custom-hr">
        </div>

        <div v-if="roles && roles.length > 0" class="w-full flex flex-col space-y-3 mt-6">
          <div 
            v-for="(role, index) in roles" 
            :key="`role-${index}`" 
            class="checkbox-container flex items-center space-x-3"
          >
            <input 
              type="checkbox" 
              :id="`role-${index}`" 
              v-model="selectedRoles"
              :value="role"
              class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
            >
            <label :for="`role-${index}`" class="text-gray-900 cursor-pointer">
              {{ role }}
            </label>
          </div>
        </div>
      </div>

      <!-- Botão continuar (sempre visível) -->
      <button class="nxp-continue-btn mt-16" :style="{ background: color }" @click="handleForward">
        Continuar
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  data() {
    return {
      selectedKeywords: [],
      selectedRoles: [],
      jobPositionReference: localStorage.getItem("vacancy_name"),
      isLoading: false,
    };
  },
  computed: {
    ...mapState("company", ["company"]),
    ...mapState("vacancy", ["vacancy"]),
    ...mapGetters("vacancy", ["complementaryKeywords", "complementaryRoles"]),
    color() {
      return this.company.base_hexcolor || "#1551b1";
    },
    keywords() {
      return this.complementaryKeywords;
    },
    roles() {
      return this.complementaryRoles;
    },
  },
  async created() {
    this.googleAnalytics();
    // Só busca dados do candidato se houver keywords ou roles
    if ((this.keywords && this.keywords.length > 0) || (this.roles && this.roles.length > 0)) {
      await this.fetchCandidateExistingData();
    }
    window.scroll(0, 0);
  },
  methods: {
    // Função para normalizar texto para comparação
    normalizeText(text) {
      if (!text || typeof text !== 'string') return '';
      
      return text
        .toLowerCase() // converte para minúsculo
        .normalize('NFD') // decompõe caracteres acentuados
        .replace(/[\u0300-\u036f]/g, '') // remove acentos
        .replace(/[^a-z0-9]/g, '') // remove tudo que não for letra ou número
        .trim();
    },

    // Função para encontrar match flexível entre dois arrays
    findFlexibleMatches(candidateItems, availableItems) {
      if (!candidateItems || !availableItems) return [];
      
      const matches = [];
      
      candidateItems.forEach(candidateItem => {
        const normalizedCandidate = this.normalizeText(candidateItem);
        
        availableItems.forEach(availableItem => {
          const normalizedAvailable = this.normalizeText(availableItem);
          
          // Verifica se há match exato após normalização
          if (normalizedCandidate === normalizedAvailable) {
            // Adiciona o item disponível (não o do candidato) para manter consistência
            if (!matches.includes(availableItem)) {
              matches.push(availableItem);
            }
          }
        });
      });
      
      return matches;
    },

    async fetchCandidateExistingData() {
      try {
        // Só executa se já temos keywords e roles carregados
        if (this.keywords.length === 0 && this.roles.length === 0) {
          return;
        }
        this.$vs.loading({
          text: 'Verificando dados existentes...'
        });
        const response = await this.$http.get('/api/v1/alerts/talent');
        const candidateData = response.data.data || response.data;

        const newKeywords = [];
        const newRoles = [];

        // Aggregate all flexible matches for keywords
        ['keywords_confirmed', 'keywords'].forEach(key => {
          if (candidateData[key] && Array.isArray(candidateData[key])) {
            newKeywords.push(...this.findFlexibleMatches(candidateData[key], this.keywords));
          }
        });
        this.selectedKeywords = [...new Set([...this.selectedKeywords, ...newKeywords])];

        // Aggregate all flexible matches for roles
        ['roles_confirmed', 'roles'].forEach(key => {
          if (candidateData[key] && Array.isArray(candidateData[key])) {
            newRoles.push(...this.findFlexibleMatches(candidateData[key], this.roles));
          }
        });
        this.selectedRoles = [...new Set([...this.selectedRoles, ...newRoles])];

        this.$vs.loading.close();
      } catch (error) {
        console.error('Erro ao buscar dados existentes do candidato:', error);
        this.$vs.loading.close();
        // Não mostra erro para o usuário pois é funcionalidade secundária
        // O usuário ainda pode preencher manualmente
      }
    },

    async saveComplementaryData() {
      try {
        this.$vs.loading({
          text: 'Salvando...'
        });

        // Calcula os itens removidos - são os disponíveis que não foram selecionados
        const removedKeywords = this.keywords
          .map(keyword => keyword)
          .filter(keywordName => !this.selectedKeywords.includes(keywordName));
        
        const removedRoles = this.roles
          .map(role => role)
          .filter(roleName => !this.selectedRoles.includes(roleName));

        const payload = {
          keywords: this.selectedKeywords,
          roles: this.selectedRoles,
          removed_keywords: removedKeywords,
          removed_roles: removedRoles
        };

        await this.$http.post('/api/v1/alerts/confirmed', payload);
        
        this.$vs.loading.close();
      } catch (error) {
        console.error('Erro ao salvar dados complementares:', error);
        this.$vs.loading.close();
        
        this.$vs.notify({
          title: "Erro ao salvar",
          text: "Não foi possível salvar as informações. Tente novamente.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      }
    },

    googleAnalytics() {
      const { company_label, vacancy_id } = this.$router.history.current.params;

      company_label && vacancy_id
        ? this.$ga.page(`${company_label}/${vacancy_id}/step/complementary-questions`)
        : this.$ga.page(`${company_label}/step/complementary-questions`);
    },

    onEditMode() {
      const currentPath = this.$router.history.current.name;
      return currentPath.slice(0, 4) == "edit";
    },

    async handleBackward() {
      if (this.onEditMode()) {
        this.$router.push({
          name: "dashboard-profile-detail"
        });
        return;
      }

      await this.$store.dispatch("step/decrementCurrentStep");
      const step = this.$store.getters["step/current"];

      const { params } = this.$router.history.current;

      this.$router.push({
        name: step.path,
        params
      });
    },

    async handleForward() {
      // Só salva dados se há perguntas complementares
      if ((this.keywords && this.keywords.length > 0) || (this.roles && this.roles.length > 0)) {
        await this.saveComplementaryData();
      }
      
      if (this.onEditMode()) {
        this.$router.push({
          name: "dashboard-profile-detail"
        });
        return;
      }

      await this.$store.dispatch("step/completeStep");
      await this.$store.dispatch("step/incrementCurrentStep");

      const step = this.$store.getters["step/current"];
      const { params } = this.$router.history.current;

      this.$router.push({
        name: step.path,
        params
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/talent/views/steps/step.scss";

.custom-hr {
  border: 0;
  height: 1px;
  background: #DFE1E6;
  margin: 8px 0;
}

input[type="checkbox"] {
  accent-color: v-bind(color);
}

input[type="checkbox"]:checked {
  background-color: v-bind(color);
  border-color: v-bind(color);
}

.alert-warning {
  margin-top: 24px;
  display: flex;
  align-items: flex-start;
  padding: 12px 16px;
  gap: 8px; 
  border-radius: 8px;
  background-color: rgba(255, 89, 0, 0.08);
}

.alert-icon {
  display: flex;
  align-items: center;
} 

.alert-content {
  font-size: 16px;
}

.checkbox-container {
  border: 0.5px solid var(--Outros-Divisrias-e-bordas, #D4D4D4);
  padding:8px 16px;
  border-radius: 8px;
  font-size: 14px;
}
</style> 